import React from 'react';
import { Icon } from './Icon';

const TrafficIcon = ({ size }: Props) => {
  return (
    <Icon type="users" color="bg-label-success" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { TrafficIcon };